<template>
  <v-switch
    v-model="closedFilter"
    :label="$t('chat.filterClosed')"
  ></v-switch>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'chat-closedFilter',
  computed: {
    ...mapGetters({
      closed: 'chat/GroupsFilters/closed'
    }),
    closedFilter: {
      get () { return this.closed },
      set (closed) { this.setClosed(closed) }
    }
  },
  methods: {
    ...mapActions({
      setClosed: 'chat/GroupsFilters/filterClosed'
    })
  }
}
</script>

<style>

</style>
